module.exports = __webpack_public_path__ + "static/media/7.cc19c2b8.png";